import { render, staticRenderFns } from "./StatusesSpan.vue?vue&type=template&id=54904068"
import script from "./StatusesSpan.vue?vue&type=script&lang=js"
export * from "./StatusesSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports